module.exports = __webpack_public_path__ + "img/ohrringe_btn.3a01778c.jpg";